import React from 'react';
import {
  Copy,
  ArrowDown,
  ArrowRight,
  Trash2,
  StickyNote,
  ClipboardPaste,
} from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { cn } from '../../lib/utils';

const WorkflowStepContextMenu = ({
  children,
  onAction,
  hasClipboard,
  disabled,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild disabled={disabled}>
      {children}
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      className="w-56 bg-white border border-slate-200"
      data-testid="step-context-menu"
    >
      <DropdownMenuItem onClick={() => onAction('copy')} data-testid="step-menu-copy">
        <Copy size={14} className="mr-2" />
        Copy action
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onAction('copy-block')} data-testid="step-menu-copy-block">
        <Copy size={14} className="mr-2" />
        Copy all actions from here
      </DropdownMenuItem>
      {hasClipboard && (
        <DropdownMenuItem onClick={() => onAction('paste')} data-testid="step-menu-paste">
          <ClipboardPaste size={14} className="mr-2" />
          Paste copied actions
        </DropdownMenuItem>
      )}
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={() => onAction('move')} data-testid="step-menu-move">
        <ArrowDown size={14} className="mr-2" />
        Move action
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onAction('move-block')} data-testid="step-menu-move-block">
        <ArrowRight size={14} className="mr-2" />
        Move all actions from here
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => onAction('delete')}
        className="text-red-600 focus:text-red-600"
        data-testid="step-menu-delete"
      >
        <Trash2 size={14} className="mr-2" />
        Delete action
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => onAction('delete-block')}
        className="text-red-600 focus:text-red-600"
        data-testid="step-menu-delete-block"
      >
        <Trash2 size={14} className="mr-2" />
        Delete all actions from here
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={() => onAction('notes')} data-testid="step-menu-notes">
        <StickyNote size={14} className="mr-2" />
        Notes
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export const WorkflowStepDragHandle = ({ onDragStart, theme = 'dark' }) => (
  <button
    type="button"
    aria-label="Move action"
    draggable
    onDragStart={(e) => {
      e.stopPropagation();
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', 'workflow-step');
      onDragStart?.();
    }}
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    className={cn(
      'flex-shrink-0 rounded p-0.5 cursor-grab active:cursor-grabbing touch-none',
      theme === 'dark' ? 'hover:bg-zinc-700/60' : 'hover:bg-slate-100',
    )}
    data-testid="step-drag-handle"
  >
    {/** icon injected by parent */}
  </button>
);

export default WorkflowStepContextMenu;
